import analytics, { VIEW_JOB_ACTION, ENGAGEMENT_CATEGORY } from '../analytics';
import { isDynamicView } from '../components/job-postings/JobPostingView';
import { isCsvJob, isDpAuthJob } from '../context/JobSearchContext';
import {
  ProfileContextType,
  ProfileType,
  isStaffProfileType,
} from '../context/ProfileContext';
import { JobPostingCSVJobType, JobPostingCSVPartnerType } from '../types/csv';
import {
  JobInternalViewType,
  JobViewType,
  PartnerJobViewType,
} from '../types/services-api';
import { UserType, isStaffType } from '../context/UserContext';
import { computeProfileCompletion } from './resumeProfileHelpers';
import {
  formatSalary,
  jobTypes,
  positionCodeToDisplayName,
} from './displayHelper';
import dayjs from 'dayjs';

export function formatJobViewTracking(
  job:
    | JobViewType
    | JobInternalViewType
    | PartnerJobViewType
    | JobPostingCSVJobType
    | JobPostingCSVPartnerType,
  user: UserType | undefined,
  profile: ProfileType
) {
  function isPartnerJob(
    obj: any
  ): obj is PartnerJobViewType | JobPostingCSVPartnerType {
    return !!obj && 'jobKey' in obj;
  }

  function isUnauthenticatedJob(
    obj: any
  ): obj is JobPostingCSVJobType | JobPostingCSVPartnerType | JobViewType {
    return !!obj && 'jobKey' in obj;
  }
  const jobId = isDpAuthJob(job)
    ? job.id
    : isPartnerJob(job)
      ? job.jobKey
      : job.jobId;

  // Mixpanel Event "view_job"
  analytics.Events.trackEvent({
    actionType: VIEW_JOB_ACTION,
    category: ENGAGEMENT_CATEGORY,
    payload: {
      jobId,
      userProfileComplete:
        isStaffProfileType(profile) && isStaffType(user)
          ? computeProfileCompletion({
              staffData: user,
              resumeProfileData: profile,
            }).percentComplete
          : 0,
      employerId: isPartnerJob(job)
        ? job.advertiserId
        : isCsvJob(job) || isDynamicView(job)
          ? 'Not Provided'
          : job.employer,
      type:
        isCsvJob(job) || isPartnerJob(job)
          ? !!jobTypes[job.jobType]
            ? jobTypes[job.jobType]
            : job.jobType
          : job.isPlanned
            ? 'Temp'
            : job.isNational
              ? 'National'
              : 'Permanent',
      position: isPartnerJob(job)
        ? job.title
        : positionCodeToDisplayName[job.position],
      isConfidential: isPartnerJob(job)
        ? false
        : isCsvJob(job)
          ? job.isConfidential === 'true'
          : job.isConfidential,
      createdDate: isPartnerJob(job)
        ? 'Unknown'
        : dayjs(job.createdDate).format('YYYY-MM-DD'),
      postedDate: isPartnerJob(job)
        ? job.postedAt
        : dayjs(job.updatedDate).format('YYYY-MM-DD'),
      office: isPartnerJob(job)
        ? job.company
        : isCsvJob(job)
          ? job.name
          : job.employerName,
      city: job.city,
      state: job.state,
      zip: job.zip,
      distance:
        isUnauthenticatedJob(job) || isPartnerJob(job)
          ? 'Not Available'
          : job.distance,
      salary: isPartnerJob(job)
        ? job.salary
        : `${
            !!job.salary
              ? formatSalary(job.salary, job.salaryUnits)
              : 'Not Available'
          }`,
    },
  });
  return null;
}
